import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { getOrderHistoriesSelectors } from 'redux/orders/selectors';
import { ORDER_STATUSES } from 'configs/localData';
import { RightOutlined } from '@ant-design/icons';
import { Modal, Card } from 'antd';
import OrderStatusStyles from './styles';
import OrderStatusContent from './OrderStatusContent';

const OrderStatus = ({ order }) => {
  const [modal, setModal] = useState({
    visible: false,
    note: null,
  });
  const orderHistories = useSelector(getOrderHistoriesSelectors);
  const handleClick = (item) => () => {
    setModal({
      visible: true,
      note: item?.note,
      status: item.status,
      item,
    });
  };
  const toggleVisible = () => {
    setModal({
      ...modal,
      visible: !modal.visible,
    });
    const timeout = setTimeout(() => {
      setModal({
        note: null,
      });
      clearTimeout(timeout);
    }, 300);
  };

  return (
    <OrderStatusStyles>
      <Modal
        bodyStyle={{ minHeight: '180px' }}
        title={i18next.t('orders.note')}
        visible={modal.visible}
        onCancel={toggleVisible}
        footer={null}
      >
        <OrderStatusContent
          onCancel={() => setModal({ visible: false })}
          orderStatus={modal.item}
          order={order}
        />
      </Modal>
      <Card>
        <div className="order-status">
          {orderHistories?.map((item, index) => (
            <>
              <div
                role="presentation"
                key={item?.value}
                className="status-title"
                style={{
                  borderColor: ORDER_STATUSES?.find(
                    (status) => status.value === item?.value,
                  )?.color,
                }}
                onClick={handleClick(item)}
              >
                <div
                  className="title-content"
                  style={{
                    // backgroundImage: `linear-gradient(to bottom right, ${ORDER_STATUSES?.find((status) => status.value === item?.value)?.color}, #fff)`,
                    background: ORDER_STATUSES?.find(
                      (status) => status.value === item?.value,
                    )?.color,
                    color: ORDER_STATUSES?.find(
                      (status) => status.value === item?.value,
                    )?.textColor,
                  }}
                >
                  {item?.text}
                </div>
              </div>
              {index < orderHistories?.length - 1 && (
                <div className="seperator">
                  <RightOutlined />
                </div>
              )}
            </>
          ))}
        </div>
      </Card>
    </OrderStatusStyles>
  );
};

OrderStatus.propTypes = {
  order: PropTypes.object,
};

export default OrderStatus;
